"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createURL = exports.createRelativePath = exports.URLEncodeObject = void 0;
/**
 * @deprecated use createRelativeURL, it handles everything
 */
function urlSepProducer() {
    let sepChar = "?";
    return function () {
        const ch = sepChar;
        sepChar = "&";
        return ch;
    };
}
exports.default = urlSepProducer;
const URLEncodeObject = (obj) => {
    try {
        const jsonObject = JSON.stringify(obj);
        return encodeURIComponent(jsonObject);
    }
    catch (exception) {
        throw new Error(`Could not encode Object: ${exception}`);
    }
};
exports.URLEncodeObject = URLEncodeObject;
/**
 * Builds the entire URL
 * @param urlOrigin adds the origin if it exists
 * @param pathType adds paths if they exist
 * @param queryParams adds queryParam if they exists
 */
const build = (urlOrigin, pathType, queryParams) => {
    let urlOriginString = "";
    if (urlOrigin) {
        const protocol = urlOrigin.protocol || "https";
        const hostName = urlOrigin.hostName || "localhost";
        const port = urlOrigin.port || 80;
        urlOriginString = `${protocol}://${hostName}:${port}`;
    }
    const paths = pathType ? pathType.join("/") : undefined;
    const pathString = paths
        ? paths.startsWith("/") ? `${paths}` : `/${paths}`
        : "";
    const hasKeys = queryParams && Object.keys(queryParams).length > 0;
    if (!hasKeys) {
        return `${urlOriginString}${pathString}`;
    }
    const queryString = Object.entries(queryParams ?? {})
        .filter(([_, value]) => {
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return value !== undefined && value !== null;
    })
        .map(([key, value]) => {
        if (Array.isArray(value)) {
            return value.map(singleValue => `${key}=${singleValue}`).join("&");
        }
        return `${key}=${value}`;
    }).join("&");
    const fullQuery = queryString ? `?${queryString}` : "";
    return `${urlOriginString}${pathString}${fullQuery}`;
};
const query = (urlOrigin, pathType, queryParams) => ({
    build: () => build(urlOrigin, pathType, queryParams)
});
const createPath = (urlOrigin, ...paths) => ({
    build: () => build(urlOrigin, [...paths]),
    queryParam: (queries) => query(urlOrigin, [...paths], queries)
});
/**
 * Creates a relative URL path
 * @param paths amount of paths to navigate through
 */
const createRelativePath = (...paths) => (createPath(undefined, ...paths));
exports.createRelativePath = createRelativePath;
/**
 * Creates a URL from origin
 * @param urlOrigin Optional urlOrigin. URL will be relative if nothing is specified
 */
const createURL = (urlOrigin) => {
    return {
        build: () => build(urlOrigin),
        paths: (...paths) => createPath(urlOrigin, ...paths)
    };
};
exports.createURL = createURL;
//# sourceMappingURL=URLUtil.js.map